import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { api } from "../lib/api";
import { CheckCircle2, Clock } from "lucide-react";

export default function PaymentSuccess() {
  const loc = useLocation();
  const [status, setStatus] = useState("pending");
  const [tries, setTries] = useState(0);

  useEffect(() => {
    const params = new URLSearchParams(loc.search);
    const sid = params.get("session_id");
    if (!sid) return;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        setStatus(data.payment_status);
        if (data.payment_status !== "paid" && tries < 15) {
          setTries((n)=>n+1);
          timer = setTimeout(poll, 2000);
        }
      } catch { if (tries < 10) { setTries((n)=>n+1); timer = setTimeout(poll, 2500); } }
    };
    poll();
    return () => clearTimeout(timer);
  }, []); // eslint-disable-line

  const paid = status === "paid";
  return (
    <div className="min-h-screen flex items-center justify-center p-6 pc-grid-bg">
      <div className="pc-card p-10 max-w-md text-center">
        {paid ? <CheckCircle2 className="mx-auto text-emerald-400 mb-3" size={40}/> : <Clock className="mx-auto text-blue-400 mb-3 animate-pulse" size={40}/>}
        <h1 className="text-2xl font-bold text-white mb-2" style={{fontFamily:'Outfit'}}>{paid ? "You're all set!" : "Finalizing your trial…"}</h1>
        <p className="text-slate-400 mb-6">{paid ? "Your Compass PM Pro trial is active. Enjoy 14 days on us." : "Hang tight — Stripe is confirming your subscription."}</p>
        <Link to="/app" data-testid="payment-continue" className="bg-gradient-to-r from-blue-500 to-blue-700 text-white px-5 py-2.5 rounded-lg font-semibold inline-block">Continue to app</Link>
      </div>
    </div>
  );
}
